import { createContext } from 'react';
import { CaseStore } from '../store/CaseStore';

export const CaseContext = createContext<CaseStore>({} as any);
